/* Benefits timeline (sections/hlth-benefits-timeline.liquid), 22 Oct 2026: the tap-to-play video,
   the credit bio dialog, and citation links that open the reference list at the cited source.
   Loaded defer, so the section is parsed; the stops' entrance is the site-wide reveal, not this file. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initVideo(root) {
    var wrap = root.querySelector('[data-tl-video]');
    if (!wrap) return;
    var video = wrap.querySelector('video');
    var start = wrap.querySelector('[data-tl-play]');
    var playBtn = wrap.querySelector('[data-tl-playpause]');
    var muteBtn = wrap.querySelector('[data-tl-mute]');
    if (!video) return;

    function sync() {
      wrap.classList.toggle('is-playing', !video.paused);
      wrap.classList.toggle('is-muted', video.muted);
      if (playBtn) playBtn.setAttribute('aria-label', video.paused ? playBtn.dataset.labelPlay : playBtn.dataset.labelPause);
      if (muteBtn) muteBtn.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
    }

    function play() {
      wrap.classList.add('is-started');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }

    if (start) start.addEventListener('click', function () { play(); if (playBtn) playBtn.focus({ preventScroll: true }); });
    if (playBtn) playBtn.addEventListener('click', function () { video.paused ? play() : video.pause(); });
    if (muteBtn) muteBtn.addEventListener('click', function () { video.muted = !video.muted; sync(); });
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  }

  function initBio(root) {
    var open = root.querySelector('[data-tl-bio-open]');
    var dialog = root.querySelector('[data-tl-bio]');
    if (!open || !dialog || typeof dialog.showModal !== 'function') return;
    open.addEventListener('click', function () { dialog.showModal(); });
    dialog.querySelector('[data-tl-bio-close]').addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  function initCites(root) {
    var refs = root.querySelector('[data-tl-refs]');
    if (!refs) return;
    root.addEventListener('click', function (e) {
      var link = e.target.closest('.hlth-tl__cite a');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      refs.open = true;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
      target.classList.add('is-cited');
      setTimeout(function () { target.classList.remove('is-cited'); }, 2000);
    });
  }

  function init(scope) {
    scope.querySelectorAll('.hlth-tl').forEach(function (section) {
      if (section.dataset.tlInit) return;
      section.dataset.tlInit = '1';
      initVideo(section);
      initBio(section);
      initCites(section);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
